import { Button } from '@medly-components/core';
import { GO_TO_HOME_PAGE } from 'constants/pageNoFound';
import { HOME_ROUTE } from 'constants/routes';
import MyMapInfo from 'pages/Map/MyMap/MyMapInfo';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const LinkNotFound = () => {
    const navigate = useNavigate();
    const backToHome = useCallback(() => {
        navigate(HOME_ROUTE);
    }, [navigate]);

    return (
        <MyMapInfo
            title={`Oops! Link Not Found`}
            description={
                <>
                    {`The page you're trying to access doesn't seem to exist.`}
                    <br /> <br />
                    Double-check the URL for any typos.
                </>
            }
            action={<Button onClick={backToHome}>{GO_TO_HOME_PAGE}</Button>}
        />
    );
};
